import { Component, OnInit, ViewContainerRef } from '@angular/core';
//import { FlightService } from '../services/flight.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe, DOCUMENT } from '@angular/common';
import { CruiseService } from '../services/cruise.service';
import { RechargeService } from '../services/recharge.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

declare var jQuery: any;
declare var moment: any;
declare var window: any;
@Component({
    selector: 'agentdashboard',
    templateUrl: './agentdashboard.component.html',
    styleUrls: ['./agentdashboard.component.css'],
    providers: [CruiseService, DatePipe]
})
export class AgentDashBoardComponent implements OnInit {

    public pgCharges: any = {
        pgcharge: [{}]
    };
    public reportType: any = ""; public dashboardOptions: any = {}; private base64string: any = ''; public SIMMarkUps: any = "";
    public hdfcUrl: any = ''; public usdRate: any = ""; public eurRate: any = ""; public roeList: any[];
    public selectedGateway: any = ""; private imageError: any = ''; public CruiseBalances: any[];
    public uploadamount: any; public ResAirline: any[]; public CruiseOrgList: any[]; public catecruise: any = ""; public LoginId: any = "";
    public charges: any; public ResLoginName: any[]; LoginNamecruise = "";
    public totalpay: any; public ResLoginNameshow: any[];
    public conveniencefee: any = 0; public pgDataDrp: any;
    public pgData: any; public ResLoginNameint: any[];
    public bookingList: any[]; public ResAirlinereq: any[];
    public statusList: any[]; public ledgerList: any[];
    public airlineList: any[]; public Resmarkupint: any[]; public pgList: any[];
    public insuranceList: any[]; public ResagentImport: any[];
    public summaryList: any[]; public ResLoginNamecru: any[];
    public agent: any = {};
    public dis: any = {};
    public selectcheckboxs: any = "";
    public Typechan: any = "";
    public catechan: any = "All";
    public catetochan: any = "A";
    public UploadTo: any = "";
    public chkDepositdate: any = "";
    public transferDate: any = "";
    public CruiseMarkUps: any = "";

    public Markup: any = "";
    public reportname: any = "";
    public SubAgent: any = "";
    public Availablelimit: any = "";
    public dashboard: any = '';
    public Classint: any = '';
    public Airlineint: any = '';
    public alldataintl: any = '';
    public Dob: any = ""; public logintype: any = ""; public agentcode: any = ""; public agentid: any = ""; public agentrole: any = "";
    public Amountper: any = ""; logindata: any = '';

    private prevDiv: any = '';
    public regOption: any = {}; public agentarray: any = {};

    constructor(@Inject(PLATFORM_ID) private platformId: Object, private CruiseService: CruiseService, private route: Router, private toastr: ToastrService, private datePipe: DatePipe, public vcr: ViewContainerRef, private sanitizer: DomSanitizer, @Inject(DOCUMENT) private document: any, private rechargeService: RechargeService) {
        if (isPlatformBrowser(this.platformId)) {
            if (sessionStorage.getItem("logindata")) {
                this.logindata = sessionStorage.getItem("logindata");
                this.agentarray = JSON.parse(this.logindata)
                this.logintype = this.agentarray.Type;
                this.agentcode = this.agentarray.CompanyCode;
                this.agentid = this.agentarray.AgentUserLoginId;
                this.agentrole = this.agentarray.roles;
            }
            else {
                this.toastr.warning("You don't have permission to view this...!");
                setTimeout(() => {
                    this.route.navigate([""]);
                }, 2000);
            }
        }
    }

    ngOnInit() {
        window.scrollTo(0, 0);

    }
    search() {
        if (this.reportType == "") {
            this.reportname = "";
            this.CruiseMarkUps = [];
        }

        if (this.prevDiv == "") {
            jQuery('#' + this.reportType).removeClass("disabledbutton");
            this.prevDiv = this.reportType;
        } else {
            //Close the prevDiv
            jQuery('#' + this.prevDiv).addClass("disabledbutton")
            this.prevDiv = this.reportType;
            // open report type div
            jQuery('#' + this.prevDiv).removeClass("disabledbutton")
        }
        if (this.reportType == "CruiseMarkupManagement") {
            this.CruiseMarkUp();
            this.reportname = "Cruise Markup Management";
        }
        if (this.reportType == "CruiseBalance") {
            this.CruiseBalance("cordelia"); this.cruiseOrgList("cordelia");
            this.reportname = "Cruise Balance";
        }
        if (this.reportType == "DailyROE") {
            this.reportname = "Daily ROE"; this.SubmitRateList();
        }
        if (this.reportType == "SIMCommission") {
            this.SIMMarkUp();
            this.reportname = "SIM Commission Management";
        }
    }
    keyPress(event: any) {
        const pattern = /[0-9\ ]/;

        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }
    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }
    IsAlphaOnly(e) {
        debugger;
        try {
            if (window.event) {
                var charCode = window.event.keyCode;
            }
            else if (e) {
                var charCode = e.which;
                var keyCode = e.keyCode;
            }
            else { return true; }
            if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode == 8) || (charCode == 32) || (charCode == 44))
                return true;
            else
                if (keyCode == 9) {
                    return true;
                }
                else {
                    this.toastr.warning("Please provide  AlphaOnly...!");
                    return false;

                }
        }
        catch (err) {
            alert(err.Description);
        }
    }
    isNumberKeyDec(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && ((charCode < 46) || (charCode > 57) || (charCode == 47))) {
            this.toastr.warning("Please provide Only Number...!");
            return false;
        }
        return true;
    }
    onlyAlphabets(e: any) {
        try {
            if (window.event) {
                var charCode = window.event.keyCode;
            }
            else if (e) {
                var charCode = e.which;
            }
            else { return true; }
            if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode == 32))
                return true;
            else
                return false;
        }
        catch (err) {
        }
    }
    Updatemarkupcruise() {
        var alldata = '';
        for (let index = 0; index < this.CruiseMarkUps.length; index++) {
            const element = this.CruiseMarkUps[index];
            if (element.CommPerc == "" || element.Comm == "") {
                this.toastr.warning("You can not leave the Columns Blank");
                return false; break;
            }
            alldata += element.code + "-" + element.CommPerc + "-" + element.Comm + ",";
        }
        this.CruiseService.getcruisemanageUpDATE(alldata, "cruisemarkup").subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.toastr.success(resp.status);
                    this.CruiseMarkUp();
                    alldata = "";
                }
                // if (resp.status == 'success') {
                //     this.toastr.success(resp.status);
                // }
            }
        )
    }
    CruiseMarkUp() {
        this.CruiseService.getcruisemanageUp("", "cruisemarkup").subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.CruiseMarkUps = resp.cruisemarkUp;
                    // console.log(this.bookingList);
                }
            }, error => {
                console.log("getAgentMarkUp Error .....");
            }
        )
    }

    CruiseBalance(supplier) {
        this.CruiseService.getCruiseBalance(supplier).subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.CruiseBalances = resp.supplierBalance;
                    // console.log(this.bookingList);
                }
            }, error => {
                console.log("AgentBalance Error .....");
            }
        )
    }

    cruiseOrgList(supplier) {
        this.CruiseService.getCruiseOrgList(supplier).subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.CruiseOrgList = resp.bookings;
                    // console.log(this.bookingList);
                }
            }, error => {
                console.log("AgentBalance Error .....");
            }
        )
    }

    // Daily ROE

    SubmitRateList() {
        this.CruiseService.getROE('', this.usdRate, this.eurRate, "", "get", "roe").subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (resp.status == "success")
                        this.roeList = resp.roeList;
                }
            }
        )
    }


    SubmitRate() {
        if (!this.usdRate) {
            this.toastr.warning("Please provide USD Rate ....");
            return false;
        }
        else {
            if (this.usdRate == 0) {
                this.toastr.warning("Please provide USD Rate ....");
                return false;
            }
        }
        this.CruiseService.getROE('', this.usdRate, this.eurRate, "", "add", "roe").subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (resp.status == "success")
                        this.toastr.success(resp.msg); else this.toastr.error(resp.msg);
                    this.SubmitRateList()
                }
            }
        )
    }

    // SIM Markup

    UpdateSIMMarkup() {
        var alldata = '';
        for (let index = 0; index < this.SIMMarkUps.length; index++) {
            const element = this.SIMMarkUps[index];
            alldata += element.code + "$" + element.CommPerc + "-" + element.Comm + "$" + element.MarkPerc + "-" + element.Markup + ",";
        }
        this.rechargeService.getSIMMarkup("", this.agent.uid, this.agent.Type, this.catecruise, this.LoginId, "Edit", "simmarkupmanage", alldata).subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.toastr.success(resp.status); //this.removemerchantCache();
                    this.SIMMarkUp();
                    alldata = ""; this.catecruise = ""; this.ResLoginNamecru = []; this.LoginNamecruise = "";
                }
                // if (resp.status == 'success') {
                //     this.toastr.success(resp.status);
                // }
            }
        )
    }

    SIMMarkUp() {
        this.rechargeService.getSIMMarkup("", this.agent.uid, this.agent.Type, this.catecruise, this.LoginId, "GET", "simmarkupmanage").subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.SIMMarkUps = resp.simmarkUp;
                    // console.log(this.bookingList);
                }
            }, error => {
                console.log("getAgentMarkUp Error .....");
            }
        )
    }
}
